import eventBus from '@/shared/event-bus';
export const bus = eventBus;
